import React, { PureComponent } from 'react';
import $ from 'jquery';

class ReviewItem extends PureComponent {
  render(){
    let album = this.props.album
    return (
      <div className={`col-md-${this.props.size} col-6 album-card`}>
        <a href={album.path}>
          <div className="image-wrapper">
            <img src={album.image}/>
            <div className="album-score-triangle" style={{borderColor: `transparent transparent ${album.color} transparent`}} >
              <div className="album-score">
                {album.score_display}
              </div>
            </div>
          </div>
          <div className="album-title">{album.title}</div>
        </a>
        <div className='artist-names'>
          {album.artist_paths.map((path, index) =>
            <a href={path} className="artist-name" key={index} >{album.artist_names[index]}</a>
          )}
        </div>
        <div className="genre-list">
          {album.genres}
        </div>
      </div>
    )
  }
}

export class Review extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      albums: this.props.albums,
      page: this.props.page,
      has_next: this.props.has_next,
      rows: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({rows: window.innerWidth >= 468});
  }


  updateReviews() {
    this.setState(({page}) => ({
      page: page + 1,
      isLoading: true,
    }));

    let data = { page: this.state.page + 1 };

    $.ajax({
      url: this.props.url,
      data: data,
      dataType: 'json',
      type: 'GET',

      success: data => {
        // set state
        this.setState({ albums: this.state.albums.concat(data.results), has_next: data.has_next });
      },

      error: (xhr, status, err) => {
        console.error(this.props.url, status, err.toString());
      },

      complete: () => {
        this.setState({ isLoading: false });
      },
    });
  }

  createNodes(){
    let i = this.props.item_size;
    let row = this.state.rows

    let albums = this.state.albums.map((album) => {
      return (
        <ReviewItem album={album} key={album.id} size={12 / i }/>
      )
    })

    if (row) {
      return albums.reduce((r, element, index) => {
        index % i === 0 && r.push([])
        r[r.length - 1].push(element)
        return r
      }, []).map((rowContent, index) => {
        return (
          <div className="row no-margin" key={index}>
            {rowContent}
          </div>
        )
      })
    } else {
      return albums
    }
  }

  render(){
    let albumNodes = this.createNodes()
    let loader = this.state.isLoading ?
    (
      <div className="text-center">
        <div className="spinner-border text-warning" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    ) : (
      <a className="see-more" onClick={() => this.updateReviews()}>SEE MORE</a>
    );

    let seeMore =  this.state.has_next ?
      (
      <div>
        <hr/>
        {loader}
      </div>
      ) : null;

    return (
      <div>
        {albumNodes}
        {seeMore}
      </div>
    )
  }
}